<div class="l_flex">
  <div
    *ngFor="
      let rating of sortedSkillRatings;
      trackBy: trackBy;
      let index = index;
      let first = first;
      let last = last
    "
    [ngSwitch]="rating | getSkillType"
    class="center-text no-mobile donut-container"
    [ngClass]="{
      'donut-container--first': index === 0,
      'donut-container--second': index === 1,
      'donut-container--third': index === 2,
      'donut-container--fourth': index === 3,
      'donut-container--larger-donut': ['Evaluation', 'Credential'].includes(
        rating.type
      )
    }"
    data-dgat="stacked-skill-ratings-bf5"
    [attr.aria-label]="skillRatingsLabel"
  >
    <dgx-profile-skills-list-skill-certification
      *ngSwitchCase="'Credential'"
      [tag]="skill"
      [isOwner]="isOwner"
      [showLock]="rating.privacyId === 0"
    ></dgx-profile-skills-list-skill-certification>

    <dgx-profile-skills-list-skill-review
      *ngSwitchCase="'Evaluation'"
      [tag]="skill"
      [isOwner]="isOwner"
      [canEvaluateSkills]="authUser?.canEvaluateSkills"
      [showLock]="rating.privacyId === 0"
    ></dgx-profile-skills-list-skill-review>

    <dgx-profile-skills-list-manager-rating
      *ngSwitchCase="'Manager'"
      [tag]="skill"
      [isOwner]="isOwner"
      [canRequestManagerRating]="authUser?.canRequestManagerRating"
      [showLock]="rating.privacyId === 0"
    ></dgx-profile-skills-list-manager-rating>

    <dgx-profile-skills-list-peer-ratings
      *ngSwitchCase="'Peer'"
      [tag]="skill"
      [isOwner]="isOwner"
      [canRequestPeerRating]="authUser?.canRequestPeerRating"
      [showLock]="rating.privacyId === 0"
    ></dgx-profile-skills-list-peer-ratings>

    <dgx-profile-skills-list-self-rating
      *ngSwitchCase="'Self'"
      [tag]="skill"
      [isOwner]="isOwner"
      [showLock]="rating.privacyId === 0"
    ></dgx-profile-skills-list-self-rating>

    <dgx-tag-rating-donut
      *ngSwitchDefault
      size="sm"
      class="ib"
      [isOwner]="isOwner"
      [showDefaultPlus]="true"
    ></dgx-tag-rating-donut>
  </div>
  <div
    *ngIf="extrasLabel"
    class="donut-container donut-container--extras"
    [ngbTooltip]="extrasTooltipText"
    [container]="'body'"
  >
    <a
      routerLink="../signals"
      [queryParams]="{ tagId: skill.tagId }"
      data-dgat="stacked-skill-ratings-95d"
      [attr.aria-label]="extrasTooltipText"
    >
      {{ extrasLabel }}
    </a>
  </div>

  <div
    *ngIf="!sortedSkillRatings.length && isOwner"
    [ngbTooltip]="i18n.dgTagRating_AddRating"
  >
    <dgx-tag-rating-donut
      size="sm"
      class="ib"
      [isOwner]="isOwner"
      [showDefaultPlus]="true"
      (click)="openAddRatingModal($event, skill)"
      (keydown)="keydownHandler($event, skill)"
      tabindex="0"
    ></dgx-tag-rating-donut>
  </div>
</div>
